import { MapViewComponent } from './map-view/map-view.component';
import { RapViewComponent } from './rap-view/rap-view.component';
import { LoadingComponent } from './loading/loading.component';
import { LogoutComponent } from './logout/logout.component';
import { GridViewComponent } from './grid-view/grid-view.component';
import { EngDrawingsComponent } from './eng-drawings/eng-drawings.component';
import { ServiceConnectionComponent } from './service-connection/service-connection.component';
import { EditFeaturesComponent } from './edit-features/edit-features.component';
import { PostingPlansComponent } from './postingplans/postingplans.component';
import { DnvEDReportsComponent } from './dnv-ed-reports/dnv-ed-reports.component';
import { WmrpConditionsComponent } from './wmrp-conditions/wmrp-conditions.component';

export const containers: any[] = [
  MapViewComponent,
  RapViewComponent,
  LoadingComponent,
  LogoutComponent,
  GridViewComponent, // MyGridComponent,
  EngDrawingsComponent,
  ServiceConnectionComponent,
  EditFeaturesComponent,
  PostingPlansComponent,
  DnvEDReportsComponent,
  WmrpConditionsComponent
];

export * from './map-view/map-view.component';
export * from './rap-view/rap-view.component';
export * from './loading/loading.component';
export * from './logout/logout.component';
export * from './grid-view/grid-view.component';
export * from './eng-drawings/eng-drawings.component';
export * from './service-connection/service-connection.component';
export * from './edit-features/edit-features.component';
export * from './postingplans/postingplans.component';
export * from './dnv-ed-reports/dnv-ed-reports.component';
export * from './wmrp-conditions/wmrp-conditions.component';